import { useRef } from 'react'

import classNames from 'classnames'
import { useEffectOnce } from 'react-use'

import { MissionCircleGraphIcon, MissionLocationIcon } from '@local/assets/icons'

import Image, { ImageProps } from '@web/components/Image'
import photoInfra from '@web/libs/media/photoInfra'
import { Nullish } from '@web/types'

import styles from './ProgressStamp.module.scss'

interface Props {
  total: number
  count: number
  number: number
  image?: Nullish<ImageProps['src']>
  allowOver: boolean
}

const ProgressCircle = ({ total, count, image, number, allowOver }: Props) => {
  const circleAreaRef = useRef<HTMLDivElement | null>(null)

  // 원 전체 둘레 (π * 2 * Radius)
  const circumference = 3.14 * 2 * 29.5
  // 채워진 정도 %
  const percentage = Math.min(100, (count / total) * 100)
  // 원 시작점 계산 (원 전체 둘레 - 채워야 할 길이)
  const dashoffset = circumference - circumference * 0.01 * percentage

  const complete = percentage === 100

  useEffectOnce(() => {
    if (!circleAreaRef.current) return
    const circles = circleAreaRef.current.querySelectorAll('circle')
    for (let i = 0; i < circles?.length; i++) {
      circles[i].setAttribute('stroke-dashoffset', `${dashoffset}`)
    }
  })

  // const conpleteName = wrapperId === 'missionCardHotReviewer' ? `달성${index + 1}번` : '완료'

  const isOver = count > total && allowOver

  return (
    <div className={styles.circle_area} ref={circleAreaRef}>
      <div className={styles.number}>{number + 1}</div>

      {count ? (
        <>
          <div
            className={classNames(styles.count, {
              [styles.type_allow_over]: isOver,
              [styles.type_complete]: !allowOver && complete,
            })}
            aria-hidden={!count}
          >
            <span className="place_blind">조회수 달성</span>
            {!allowOver && complete ? '완료' : count}
          </div>
          {isOver ? (
            <div className={styles.gradient_area} />
          ) : (
            <MissionCircleGraphIcon
              className={classNames('place_mission_icon_circle_graph', styles.icon_circle)}
              aria-hidden={!count}
            />
          )}
        </>
      ) : null}
      <>
        {image ? (
          <div className={styles.icon_area}>
            <Image
              className={styles.img}
              src={image}
              width="100%"
              height="100%"
              alt="리뷰"
              thumbnailType={photoInfra.type.f220_220_70_sharpen}
            />
          </div>
        ) : (
          <div className={styles.default_image_area}>
            <MissionLocationIcon className={styles.icon_location} aria-hidden="true" />
          </div>
        )}
      </>
    </div>
  )
}

export default ProgressCircle
